import { AvatarDataSource, AvatarLevel, ClientAvatar as PrismaClientAvatar } from "@prisma/client";
import { DailyRoutineItem } from "@/app/types/client-avatar/UserClientAvatar";

export { AvatarDataSource };

export type ClientAvatarLLMPayload = {
  imagePrompt?: string;
  name: string;
  role: string;
  gender: string;
  ageRange: string[];
  locationRange: string[];
  educationLevel: string;
  incomeRange: string;
  companyType: string;
  companySize: string;
  market: string;

  snapshotSummary: string;
  priority: string;

  scoreFit: number;
  scoreConfidence: number;
  scorePain: number;

  desires: string[];
  frustrations: string[];
  dreams: string[];
  fears: string[];
  costTime: string;
  costEnergy: string;
  costOpportunity: string;

  currentSituation: string[];
  desiredSituation: string[];
  dailyRoutine: DailyRoutineItem[];
  mindset: string;
  blockers: string[];

  falseBelief: string[];
  purchaseObjections: string[];
  objectionHandler: string[];

  privateQuotes: string[];
  publicQuotes: string[];
  dominantKeywords: string[];
  emotionalLanguage: string[];
  copyAdvice: string;

  fitSummary: string;
  urgencyLevel: AvatarLevel | null;
  urgencyDescription: string;
  purchasePotential: AvatarLevel | null;
  purchasePotentialDescription: string;
  idealClientCriteria: string[];
  nonIdealClientCriteria: string[];
  purchaseTriggers: string[];
  whereToFind: string[];
  voiceOfTrust: string;
  approachAngle: string;
};

export type ClientAvatarLite = Omit<PrismaClientAvatar, "offerId" | "createdAt" | "updatedAt">;

export enum AvatarExtractionAction {
  CREATE_NEW = "CREATE_NEW",
  ENRICH_EXISTING = "ENRICH_EXISTING",
}

export type ClientAvatarExtractionResult = {
  action: AvatarExtractionAction;
  targetAvatarId: number | null;
  avatarData: ClientAvatarLLMPayload;
};
